export class Box {
    bgImg: string;
    title: string;
    description: string;
    link: string;

    constructor(bgImg: string,
        title: string,
        description: string,
        link: string,
    ) {
        this.bgImg = bgImg;
        this.title = title;
        this.description = description;
        this.link = link;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/box.ts